import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuth } from "./AuthContext";
import { US_STATES, COUNTRIES } from "../geoOptions";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalBoxStyle = {
  background: "#fff",
  borderRadius: 10,
  padding: "16px",
  width: "90vw",
  maxWidth: 800,
  height: "85vh",
  display: "flex",
  flexDirection: "column",
  boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
};

function PdfModal({ title, src, onClose }) {
  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalBoxStyle} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
          <strong style={{ fontSize: 16 }}>{title}</strong>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", lineHeight: 1 }}
          >
            ✕
          </button>
        </div>
        <iframe src={`${src}#toolbar=0&navpanes=0`} title={title} style={{ flex: 1, border: "none", borderRadius: 6 }} />
      </div>
    </div>
  );
}



export default function TradingAccountInformation() {
  const navigate = useNavigate();



  const [form, setForm] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    postalCode: "",
    country: "USA",
    dateOfBirth: "",
    ssn: "",
  });



  const { user } = useAuth();
  const [photoIdFile, setPhotoIdFile] = useState(null);
  const [photoIdPreview, setPhotoIdPreview] = useState("");
  const [photoIdError, setPhotoIdError] = useState("");
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  const handlePhotoIdChange = (e) => {
  const file = e.target.files?.[0];
  setPhotoIdError("");
  setPhotoIdPreview("");
  setPhotoIdFile(null);

  if (!file) return;

  const allowed = ["image/jpeg", "image/png", "image/webp", "application/pdf"];
  const maxBytes = 8 * 1024 * 1024; // 8MB

  if (!allowed.includes(file.type)) {
    setPhotoIdError("Please upload a JPG, PNG, WEBP, or PDF.");
    return;
  }

  if (file.size > maxBytes) {
    setPhotoIdError("File is too large. Max size is 8MB.");
    return;
  }

  setPhotoIdFile(file);

  // Preview only for images (not PDF)
  if (file.type.startsWith("image/")) {
    const url = URL.createObjectURL(file);
    setPhotoIdPreview(url);
  }

  if (!agreements.customer || !agreements.account) {
  alert("You must accept all agreements to continue.");
  return;
}

};
    
  const [agreements, setAgreements] = useState({
  customer: false,
  account: false,
});

  function updateField(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

async function handleSubmit(e) {
  e.preventDefault();

  try {

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/alpaca/create-account`,
      {
        firstName: form.firstName,
        middleName: form.middleName,
        lastName: form.lastName,
        email: form.email,
        phone: form.phone,
        address: form.address,
        city: form.city,
        state: form.state,
        postalCode: form.postalCode,
        country: form.country,
        dateOfBirth: form.dateOfBirth,
        ssn: form.ssn,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("spectraToken")}`,
        },
      }
    );

              console.log("Alpaca account created:", response.data);

                 localStorage.setItem(`accountStatus_${user.username}`, "onboarded")
                navigate("/TradingAccountInformationSubmitted");
              
         } catch (error) {

              const data = error.response?.data;

              const message =
                (data && typeof data === "object" && (data.error || data.message)) ||
                (typeof data === "string" ? data : null) ||
                error.message ||
                "Something went wrong submitting your information. Please try again.";

              console.error("Onboarding error:", data || error.message);

              alert(message);

        }
     }


     
     
     const inputStyle = {
       width: "100%",
       padding: "10px",
       marginTop: 6,
       marginBottom: 14,
       borderRadius: 8,
       border: "1px solid #ccc",
     };
  
     return (
        <div style={{ maxWidth: 900, margin: "0 auto", padding: "32px 24px" }}>
        {showPrivacyModal && (
          <PdfModal
            title="SMA Privacy Document"
            src="/SMAPrivacyPolicyDocument.pdf"
            onClose={() => setShowPrivacyModal(false)}
          />
        )}
          {/* Header row */}
       <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: 16,
        marginBottom: 20,
      }}
     >
      <div>
        <h2 style={{ marginBottom: 6 }}>Trading Account Information</h2>
        <p style={{ marginBottom: 0, opacity: 0.85 }}>
          Enter your details to complete account verification.
        </p>
      </div>

      <img
        src="/spectra-logo.jpg"
        alt="Spectra"
        style={{ height: 64, width: "auto", objectFit: "contain" }}
      />
     </div>

     {/* Form */}
      <form onSubmit={handleSubmit}>
       <label>First Name</label>
       <input
        name="firstName"
        value={form.firstName}
        onChange={updateField}
        style={inputStyle}
      />

      <label>Middle Name (optional)</label>
      <input
        name="middleName"
        value={form.middleName}
        onChange={updateField}
        style={inputStyle}
      />

      <label>Last Name</label>
      <input
        name="lastName"
        value={form.lastName}
        onChange={updateField}
        style={inputStyle}
      />

      <label>Email</label>
      <input
        name="email"
        value={form.email}
        onChange={updateField}
        style={inputStyle}
      />

      <label>Phone</label>
      <input
        name="phone"
        value={form.phone}
        onChange={updateField}
        style={inputStyle}
      />

      <label>Street Address</label>
      <input
        name="address"
        value={form.address}
        onChange={updateField}
        style={inputStyle}
      />

      <label>City</label>
      <input
        name="city"
        value={form.city}
        onChange={updateField}
        style={inputStyle}
      />

      <label>State</label>
      {form.country === "USA" ? (
        <select
          name="state"
          value={form.state}
          onChange={updateField}
          style={inputStyle}
        >
          <option value="">Select a state</option>
          {US_STATES.map(([code, name]) => (
            <option key={code} value={code}>
              {name}
            </option>
          ))}
        </select>
      ) : (
        <input
          name="state"
          value={form.state}
          onChange={updateField}
          placeholder="State / Province / Region"
          style={inputStyle}
        />
      )}

      <label>Postal Code</label>
      <input
        name="postalCode"
        value={form.postalCode}
        onChange={updateField}
        style={inputStyle}
      />

      <label>Country</label>
      <select
        name="country"
        value={form.country}
        onChange={(e) => {
          const { value } = e.target;
          // Clear the state whenever the country changes so a US code can't carry over.
          setForm((prev) => ({ ...prev, country: value, state: "" }));
        }}
        style={inputStyle}
      >
        {COUNTRIES.map(([code, name]) => (
          <option key={code} value={code}>
            {name}
          </option>
        ))}
      </select>

      <label>Date of Birth</label>
      <input
        type="date"
        name="dateOfBirth"
        value={form.dateOfBirth}
        onChange={updateField}
        style={inputStyle}
      />

      <label>Social Security Number (9 digits)</label>
      <input
        name="ssn"
        value={form.ssn}
        onChange={updateField}
        placeholder="123-45-6789"
        inputMode="numeric"
        maxLength={11}
        autoComplete="off"
        style={inputStyle}
      />

      <label style={{ display: "block", marginTop: 14, textAlign: "left" }}>
        Government Photo ID (upload)
      </label>

      <input
        type="file"
        accept=".jpg,.jpeg,.png,.webp,.pdf"
        onChange={handlePhotoIdChange}
        style={{ width: "100%", marginTop: 6 }}
      />

      <div style={{ fontSize: 12, color: "#666", marginTop: 6, textAlign: "left" }}>
        Accepted: JPG, PNG, WEBP, PDF • Max 8MB
      </div>

      {photoIdError && (
        <div style={{ color: "crimson", marginTop: 8, textAlign: "left" }}>
          {photoIdError}
        </div>
      )}

      {photoIdFile && !photoIdError && (
        <div style={{ marginTop: 10, textAlign: "left", fontSize: 13 }}>
          Selected: <strong>{photoIdFile.name}</strong>
        </div>
      )}

      {photoIdPreview && (
        <div style={{ marginTop: 10, textAlign: "left" }}>
          <img
            src={photoIdPreview}
            alt="Photo ID preview"
            style={{
              maxWidth: "260px",
              width: "100%",
              borderRadius: 8,
              border: "1px solid #ddd",
            }}
          />
        </div>
      )}

      <button
        type="button"
        onClick={() => setShowPrivacyModal(true)}
        style={{
          marginTop: 18,
          marginBottom: 14,
          padding: "9px 22px",
          borderRadius: 6,
          border: "1px solid #00bfff",
          background: "transparent",
          color: "#00bfff",
          fontWeight: 600,
          cursor: "pointer",
          fontSize: 14,
          display: "block",
        }}
      >
        View SMA Privacy Document
      </button>


      <label>
               <input
        type="checkbox"
        checked={agreements.customer}
        onChange={() =>
        setAgreements({ ...agreements, customer: !agreements.customer })
        }
       />
        I agree to the Customer Agreement
        </label>

       <label>
       <input
            type="checkbox"
            checked={agreements.account}
            onChange={() =>
            setAgreements({ ...agreements, account: !agreements.account })
         }
        />
          I agree to the Account Agreement
        </label>

      <div
          style={{
          marginTop: 24,
          display: "flex",
          gap: 16,
          justifyContent: "flex-start",
        }}
      >
        <button
          type="button"
          onClick={() => navigate("/Dashboard")}
          style={{
          padding: "10px 14px",
          borderRadius: "8px",
          background: "#eee",
          border: "1px solid #ccc",
          cursor: "pointer",
       }}
       >
          Return to Dashboard
          </button>


        <button
            type="submit"
            style={{
            padding: "10px 20px",
            borderRadius: 8,
            border: "none",
            background: "#FFD700",
            color: "#111",
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Submit for Verification
        </button>
      </div>
    </form>
  </div>
);
}